/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import ActivityItem from "components/organisationActivities/ActivityItem";
import { Trans } from "react-i18next";

class ActivitiesTable extends Component {
  state = {
    sort_by: "date", // training name by default
    sort_dir: "desc",
  };

  aDate = "";
  aEmployee = "";
  aType = "";
  aPosName = "";
  aManager = "";
  aIsApprovedCode = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.aType = "";
    this.aEmployee = "";
    this.aPosName = "";
    this.aDate = "";
    this.aManager = "";
    this.aIsApprovedCode = "";

    switch (this.state.sort_by) {
      case "aType":
        this.aType = `_${this.state.sort_dir}`;
        break;
      case "aEmployee":
        this.aEmployee = `_${this.state.sort_dir}`;
        break;
      case "aPosName":
        this.aPosName = `_${this.state.sort_dir}`;
        break;
      case "aDate":
        this.aDate = `_${this.state.sort_dir}`;
        break;
      case "aManager":
        this.aManager = `_${this.state.sort_dir}`;
        break;
      case "aIsApprovedCode":
        this.aIsApprovedCode = `_${this.state.sort_dir}`;
        break;
      default:
        this.aDate = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = () => {
    const sorted = this.props.data.sort((a, b) => {
      switch (this.state.sort_by) {
        case "aDate":
          return this.state.sort_dir === "desc"
            ? new Date(a.date) - new Date(b.date)
            : new Date(b.date) - new Date(a.date);
        case "aEmployee":
          return this.state.sort_dir === "desc"
            ? a.employee?.name.localeCompare(b.employee?.name)
            : b.employee?.name.localeCompare(a.employee?.name);
        case "aType":
          return this.state.sort_dir === "desc"
            ? a.type?.label.localeCompare(b.type?.label)
            : b.type?.label.localeCompare(a.type?.label);
        case "aPosName":
          return this.state.sort_dir === "desc"
            ? a.position?.name.localeCompare(b.position?.name)
            : b.position?.name.localeCompare(a.position?.name);
        case "aManager":
          return this.state.sort_dir === "desc"
            ? a.reportPersonel?.name.localeCompare(b.reportPersonel?.name)
            : b.reportPersonel?.name.localeCompare(a.reportPersonel?.name);
        case "aIsApprovedCode":
          return this.state.sort_dir === "desc"
            ? a.isApprovedCode?.label.localeCompare(b.isApprovedCode?.label)
            : b.isApprovedCode?.label.localeCompare(a.isApprovedCode?.label);
        default:
          return this.state.sort_dir === "desc"
            ? new Date(a.date) - new Date(b.date)
            : new Date(b.date) - new Date(a.date);
      }
    });

    return sorted.map((a) => {
      return <ActivityItem key={`${a.date}-${a.employee.id}`} act={a} />;
    });
  };

  render() {
    this.setSotingClassNames();
    return (
      <div
        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        id="kayitliEgitimler"
        style={{ display: "block" }}
      >
        <table
          className="table display responsive tgOrgAct dataTable no-footer dtr-none collapsed"
          id="dataTablePersonel"
        >
          <thead>
            <tr>
              <th
                onClick={() => this.reOrder("aDate")}
                className={`all sorting${this.aDate}`}
              >
                <div className="tableTitle">
                  <Trans desc="Tarih">10068</Trans>
                </div>
              </th>
              <th
                onClick={() => this.reOrder("aType")}
                className={`all sorting${this.aType}`}
              >
                <div className="tableTitle">
                  <Trans desc="Tip">10069</Trans>
                </div>
              </th>
              <th
                onClick={() => this.reOrder("aEmployee")}
                className={`all sorting${this.aEmployee}`}
              >
                <div className="tableTitle">
                  <Trans desc="Çalışan">10070</Trans>
                </div>
              </th>
              <DesktopBreakpoint>
                <th
                  onClick={() => this.reOrder("aPosName")}
                  className={`desktop sorting${this.aPosName}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Pozisyon İsmi">10064</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("aManager")}
                  className={`desktop sorting${this.aManager}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Rapor Ettiği Çalışan">10072</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("aIsApprovedCode")}
                  className={`desktop sorting${this.aIsApprovedCode}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Durum">10018</Trans>
                  </div>
                </th>
              </DesktopBreakpoint>
            </tr>
          </thead>
          <tbody>
            {this.renderData()}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ActivitiesTable;
